export default __webpack_public_path__ + "static/media/moonHalf.42100b0e.png";